import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { CrudService } from '~services/crud.service';
import { BonusContractRequest, BonusEventRequest } from '~models/bonus.model';

@Injectable()
export class BonusApiService {
  get fracIdsAndJobNamesRoute(): string {
    return environment.api + '/frac_id_job_name';
  }

  get bonusMinesRoute(): string {
    return environment.api + '/bonus_mines';
  }

  get regionsForBonusRoute(): string {
    return environment.api + '/bonus_regions';
  }

  get bonusContractsRoute(): string {
    return environment.api + '/bonus_contracts';
  }

  get createBonusEventRoute(): string {
    return environment.api + '/create_bonus_event';
  }

  get bonusEventsRoute(): string {
    return environment.api + '/bonus_events';
  }

  get bonusEventRoute(): string {
    return environment.api + '/bonus_event';
  }

  get baseRoute(): string {
    return environment.api + '/gohawk_bonus_events';
  }

  constructor(private crud: CrudService) {}

  getFracIdsAndJobNames() {
    return this.crud.get(this.fracIdsAndJobNamesRoute);
  }

  getBonusMines(fracIds: string[]) {
    return this.crud.post(this.bonusMinesRoute, fracIds);
  }

  getRegionsForBonus() {
    return this.crud.get(this.regionsForBonusRoute);
  }

  getBonusContracts(body: BonusContractRequest) {
    return this.crud.post(this.bonusContractsRoute, body);
  }

  createBonusEvent(body) {
    return this.crud.post(this.createBonusEventRoute, body);
  }

  getBonusEvents() {
    return this.crud.get(this.bonusEventsRoute);
  }

  getArchivedBonusEvents() {
    return this.crud.get(this.bonusEventsRoute + '/archived');
  }

  getBonusEvent(id) {
    return this.crud.get(this.bonusEventRoute + '/' + id);
  }

  deleteBonusEvent(id: number) {
    return this.crud.post(this.baseRoute + '/' + id + '/remove_update');
  }

  updateBonusEvent(id: number, body) {
    return this.crud.post(this.baseRoute + '/' + id + '/remove_update', body);
  }
}
